import Classnames from 'classnames'
import { useAtom } from 'jotai'
import produce from 'immer'

// helper functions
import { returnBlockValue } from '@/utils/op-types/helperFunctions'

import Card from '@/components/optypes/frontend/StickyPage/blocks/Card'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
} from '@/utils/op-types/store'

import { RiExternalLinkLine } from 'react-icons/ri'

const HeaderBlock = ({ id, block, design, content }) => {
  const [builder] = useAtom(isBuilder)
  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)

  return (
    <Card>
      <div className="md:flex items-center justify-between">
        <div className="">
          <div className="text-lg font-bold">
            {returnBlockValue('title', 'content', opBlocks[block], content)}
          </div>

          <div className="text-sm">
            {returnBlockValue('desc', 'content', opBlocks[block], content)}
          </div>
        </div>

        <div className="mt-3 md:mt-0">
          <button
            className="py-2 px-3 font-bold text-lg rounded flex items-center space-x-3"
            onClick={() => {
              if (!builder) {
                if (
                  returnBlockValue(
                    'buttonurl',
                    'content',
                    opBlocks[block],
                    content
                  )
                ) {
                  window
                    .open(
                      returnBlockValue(
                        'buttonurl',
                        'content',
                        opBlocks[block],
                        content
                      ),
                      '_blank'
                    )
                    .focus()
                }
              }
            }}
            style={{
              backgroundColor: returnBlockValue(
                'buttoncolor',
                'design',
                opBlocks[block],
                design
              ),
              color: returnBlockValue(
                'buttontextcolor',
                'design',
                opBlocks[block],
                design
              ),
            }}
          >
            <div className="">
              {returnBlockValue(
                'buttontext',
                'content',
                opBlocks[block],
                content
              )}
            </div>

            <div className="">
              <RiExternalLinkLine />
            </div>
          </button>
        </div>
      </div>
    </Card>
  )
}

export default HeaderBlock
